module.exports = __webpack_public_path__ + "static/img/清廉之窗@4x.93f6c68f.png";